import React from "react";

import "./AddressCard.scss";
import Card from "../Card";

const AddressCard = ({ contact }) => (
  <Card
    title="Address"
    body={
      <div className="address-card">
        {contact.address !== null && contact.address.addressLine1 ? (
          <>
            {" "}
            <div className="address-card__strapline">
              {contact.address.addressLine1}
            </div>
            <div className="address-card__strapline">
              {contact.address.addressLine2} {contact.address.postalCode}
            </div>
            <div className="address-card__strapline">
              {contact.address.city}
            </div>
            <div className="address-card__strapline">
              {contact.address.province} {contact.address.postalCode}
            </div>{" "}
          </>
        ) : (
          <div className="address-card__strapline">
            {"-"} {"-"} {"-"} {"-"}
          </div>
        )}
      </div>
    }
  />
);

export default AddressCard;
